var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled, { keyframes } from "styled-components";
import { useAnimation } from "framer-motion";
import { Flex } from "./Flex";
import { Text } from "./Text";
const circleColorPicker = (colors, index, hexAlphaOpacities) => {
    const colorMap = {
        1: `${colors.color}${hexAlphaOpacities.HEX_ALPHA_OPACITY_14}`,
        2: `${colors.color}${hexAlphaOpacities.HEX_ALPHA_OPACITY_29}`,
        3: `${colors.color}${hexAlphaOpacities.HEX_ALPHA_OPACITY_43}`,
        4: `${colors.color}${hexAlphaOpacities.HEX_ALPHA_OPACITY_57}`,
        5: `${colors.color}${hexAlphaOpacities.HEX_ALPHA_OPACITY_71}`,
        6: `${colors.color}${hexAlphaOpacities.HEX_ALPHA_OPACITY_86}`,
        7: `${colors.color}${hexAlphaOpacities.HEX_ALPHA_OPACITY_100}`,
    };
    return colorMap[index];
};
export var SpinnerSize;
(function (SpinnerSize) {
    SpinnerSize[SpinnerSize["SMALL"] = 0] = "SMALL";
    SpinnerSize[SpinnerSize["MEDIUM"] = 1] = "MEDIUM";
    SpinnerSize[SpinnerSize["LARGE"] = 2] = "LARGE";
    SpinnerSize[SpinnerSize["BUTTON"] = 3] = "BUTTON";
})(SpinnerSize || (SpinnerSize = {}));
const rotate = keyframes `
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(720deg);
  }
`;
const CircleContainer = styled.div `
  width: 25px;
  height: 25px;
  display: inline-block;
  animation: ${rotate} 2.5s linear infinite;
`;
const LoadingCircle = styled.li `
  background-color: ${(props) => circleColorPicker(props.spinnerColor ? { color: props.spinnerColor } : props.theme.colors.loadingSpinner, props.index, props.theme.hexAlphaOpacities)};
  border-radius: 100px;
  display: block;
  height: 25px;
  width: 25px;
  position: absolute;
  transform: rotate(${(props) => props.offset}deg) translate(${(props) => props.circleSize / 2}px)
    rotate(${(props) => (props.offset * 2) / (props.index + 1)}deg);
`;
const sizeMap = {
    [SpinnerSize.LARGE]: "150px",
    [SpinnerSize.MEDIUM]: "100px",
    [SpinnerSize.SMALL]: "50px",
    // 17.5px specifically to keep the primary Button component from changing size in its loading state
    [SpinnerSize.BUTTON]: "17.5px",
};
const scaleMap = {
    [SpinnerSize.LARGE]: "scale(1)",
    [SpinnerSize.MEDIUM]: "scale(0.5)",
    [SpinnerSize.SMALL]: "scale(0.25)",
    [SpinnerSize.BUTTON]: "scale(0.15)",
};
export const LoadingSpinner = (_a) => {
    var { loadingText, size = SpinnerSize.LARGE, spinnerColor } = _a, props = __rest(_a, ["loadingText", "size", "spinnerColor"]);
    const rotateControl = useAnimation();
    let offset = 45;
    const angle = 360 / 8;
    const circleSize = 125;
    rotateControl.start("start");
    return (React.createElement(Flex, Object.assign({}, props),
        React.createElement(Flex, { width: sizeMap[size], height: sizeMap[size], justifyContent: "center", alignItems: "center", sx: { transform: scaleMap[size] }, "data-testid": "loadingSpinner" },
            React.createElement(Text, { position: "absolute" }, loadingText),
            React.createElement(CircleContainer, null, [...Array(8)].map((_, i) => {
                offset += angle;
                return (React.createElement(LoadingCircle, { offset: offset, circleSize: circleSize, spinnerColor: spinnerColor, index: i, key: i }));
            })))));
};
